import { emptySplitApi } from "../baseApi";
import { PortalCacheTags } from "../cacheTags";

export const sessionApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    portalLogout: builder.mutation<{ ok: true }, { code: string; sessionId: string; sessionEmail: string }>({
      query: ({ code, sessionId, sessionEmail }) => ({
        url: `session/logout`,
        method: `POST`,
        data: { sessionEmail },
        headers: {
          [`X-Portal-Session`]: sessionId,
          [`X-Portal-Hash-Code`]: code,
        },
      }),
      invalidatesTags: [
        { type: PortalCacheTags.Invoice },
        { type: PortalCacheTags.Contact },
        { type: PortalCacheTags.Quote },
      ],
    }),
  }),
});

export const {
  usePortalLogoutMutation,
} = sessionApi;
